var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM10.4 5.6C10.4 6.92548 9.32548 8 8 8C6.67452 8 5.6 6.92548 5.6 5.6C5.6 4.27452 6.67452 3.2 8 3.2C9.32548 3.2 10.4 4.27452 10.4 5.6ZM7.99999 14.8C9.42723 14.8 10.7518 14.3603 11.8455 13.609C12.3286 13.2771 12.5351 12.645 12.2542 12.1306C11.672 11.0642 10.4722 10.4 7.99995 10.4C5.52775 10.4 4.32797 11.0642 3.74571 12.1305C3.46484 12.6449 3.67128 13.2771 4.15437 13.6089C5.24815 14.3603 6.57272 14.8 7.99999 14.8Z",
    fill: "#EFE6D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersIcon);
export default __webpack_public_path__ + "static/media/users-icon.24829ae1709bc9e04a24eba6646b1c5b.svg";
export { ForwardRef as ReactComponent };